import React from "react";

const HomePageHeader = ({ onAddHotel }) => {
  return (
    <div className="mb-8 mt-8 flex items-center justify-between gap-4 px-6">
      <div>
        <h1 className="mb-2 text-3xl font-bold text-gray-900">Liste des hôtels</h1>
        <p className="text-gray-600 text-lg">Dashboard principal avec données enrichies et actions rapides</p>
      </div>

      {onAddHotel && (
        <button
          type="button"
          onClick={onAddHotel}
          className="inline-flex items-center gap-2 px-4 py-2 rounded-md bg-[#365644] text-white text-sm font-semibold shadow-sm hover:bg-[#2b4336] transition"
        >
          + Ajouter un hôtel
        </button>
      )}
    </div>
  );
};

export default HomePageHeader;
